import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useClubAthleteHttp } from '@/core/api/club-athletes'
import { ClubAthlete, ClubAthletePayload } from '@/core/models/club-athlete'

export type ClubAthleteCollection = {
    data: Array<ClubAthlete>,
    meta?: MetaPayload,
    links?: any
}

const state: ClubAthleteCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const clubAthleteCollection: Module<ClubAthleteCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: ClubAthleteCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: ClubAthletePayload) => {
                state.data.push(new ClubAthlete(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useClubAthleteHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: ClubAthleteCollection): ClubAthleteCollection => {
            return state
        }
    }
}
